import { useMemo } from 'react'

import { useUnit } from 'effector-react'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { $hasMassMessagesPermission } from '@/models/permissions.ts'
import { handleError } from '@/utils/error'

import { queueService } from '../service/queue'

export const useMessageQueue = () => {
  const creatorId = useUnit($creatorId)
  const hasMassMessagesPermission = useUnit($hasMassMessagesPermission)

  const queryKey = ['messagesQueue', creatorId]

  const query = useQuery(
    queryKey,
    () => {
      return queueService.getQueueList(creatorId!)
    },
    {
      enabled: !!creatorId && hasMassMessagesPermission,
      initialData: [],
      onError: (error) => {
        handleError(
          error,
          'Something went wrong while getting message queue',
          query.refetch,
        )
      },
    },
  )

  const listSortedByDate = useMemo(
    () =>
      query.data?.sort((a, b) => {
        return new Date(b.date).getTime() - new Date(a.date).getTime()
      }) ?? [],
    [query.data],
  )

  return {
    ...query,
    messagesQueue: listSortedByDate,
    queryKey,
  }
}
